import { nextTick, onBeforeMount, onBeforeUnmount, onMounted, reactive, ref, computed } from 'vue';
import * as d3 from 'd3';
import { activityDetailStore } from '@client/store/activityDetailStore';
import unitHelper from '@client/helper/unit';

export default function useXAxisConfig({ isPortion }) {
  const activityDetailStoreRef = activityDetailStore();

  const summary = computed(() => activityDetailStoreRef.activityDetail?.summary);
  const graphList = computed(() => activityDetailStoreRef.activityDetail?.graphList);
  const chartModel = computed(() => activityDetailStoreRef.chartModel);

  const frameSelectedData = computed(() => activityDetailStoreRef.frameSelectedData);

  // 接口返回的x轴刻度定义
  const xTicksDefault = computed(() => {
    if(!graphList.value||!graphList.value.length) return []
    if (chartModel.value === 'time') {
      return graphList.value?.[0].graphItem.xScaleArr || [];
    }

    if (chartModel.value === 'distance') {
      return graphList.value?.[0].graphItem.xScaleArr || [];
    }

    return [];
  });

  const xAxisConfigDefault = computed(() => {
    let startX = 0;
    let endX = 0;
    let xTicks = [];

    if (chartModel.value === 'time') {
      xTicks = (graphList.value&&graphList.value.length && graphList.value[0].graphItem.xScaleArr) || [];

      // 计算出最大最小值
      endX = summary.value.workoutTime || 0;

      endX = d3.max([].concat(xTicksDefault.value, [endX]));
    }

    if (chartModel.value === 'distance') {
      endX = summary.value.distance || 0;

      // 是否定义x轴刻度
      // - X轴刻度分为3段 - 距离为D - D/3=E，E往下取小数点后2位F（E若＞100，则往下取小数点后1位），那么刻度间隔为F - 刻度为(0，F，2F，3F)
      let E = endX / 3;
      if (E > 100) {
        E = Math.floor(E * 10) / 10;
      } else {
        E = Math.floor(E * 100) / 100;
      }
      xTicks = [0, E, 2 * E, 3 * E];
    }

    return {
      startX,
      endX,
      xTicks
    };
  });

  const xAxisConfig = computed(() => {
    if (isPortion && frameSelectedData.value) {
      return {
        startX: frameSelectedData.value.start,
        endX: frameSelectedData.value.end,
        xTicks: [frameSelectedData.value.start, frameSelectedData.value.end]
      };
    } else {
      return xAxisConfigDefault.value;
    }
  });

  return {
    xAxisConfig
  };
}
